module.exports = __webpack_public_path__ + "img/sunjianjirou.2cdec8e7.jpg";